__turbopack_context__.v({
  "itemLoader": "ItemLoader-module-scss-module__1USMAa__itemLoader",
});
